import {  HttpClientModule } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MessagesModule } from 'primeng/messages';
import { PanelModule } from 'primeng/panel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { CanvasDirective } from '../canvas-directive/canvas.directive';
import { DialogService } from 'primeng/dynamicdialog';
import { ExportDialogComponent } from '../export-dialog/export-dialog.component';
import { FormsModule } from '@angular/forms';
import { Message } from 'primeng/api';

@Component({
  selector: 'app-render-view',
  standalone: true,
  imports: [
    PanelModule,
    HttpClientModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    ButtonModule,
    TooltipModule,
    ToastModule,
    CanvasDirective,
    FormsModule,
    MessagesModule
  ],
  templateUrl: './render-view.component.html',
  styleUrl: './render-view.component.scss',
  providers: [DialogService]
})
export class RenderViewComponent implements OnChanges {
  @Input() renderName: string | undefined | null;
  @Output() renderNameChange = new EventEmitter<string>();
  @Output() resetEditorState = new EventEmitter<void>();
  @Input() layerOrder: string[] | null = []
  showMessage = true

  initialMessages: Message[] = [
    {
      severity: 'info',
      detail: 'This is a scaled down version of the render.' +
      'Layers/Effects such as Outlines, Textures, Contours, etc... ' +
      'may appear different (smaller) on the final image.',
    }
  ];

  constructor(
    private dialogService: DialogService,
  ){}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.layerOrder && this.layerOrder?.length > 1) {
      this.showMessage = false
    }
  }

  openExportDialog(){
    this.dialogService.open(ExportDialogComponent, {
      header: 'Export Image As',
      width: 'min(30%, 400px)',
    });
  }

  updateRenderName(){
    this.renderNameChange.emit(String(this.renderName))
  }
}
